import {
    WorkingHourMapperParameter,
    WorkingHourFactory,
} from "@/v2/models/warehouse-working-hours.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import httpMixin from "@/v2/mixins/http.js";
import { timeToDate } from "@/v2/utils/date.js";

export default {
    mixins: [mapperMixin, httpMixin],
    computed: {
        workingHourUrl: {
            get() {
                return window.bo.workingHourUrl;
            },
        },
    },
    methods: {
        _workingHourMapper(workinghour) {
            return {
                id: workinghour.id,
                warehouse_id: workinghour.warehouse_id,
                day: workinghour.day,
                day_label: workinghour.day_label ?? null, // not from DB
                start_time: workinghour.start_time ?? null,
                end_time: workinghour.end_time ?? null,
                checked: workinghour.checked ?? false, // not from DB
                created_at: workinghour.created_at
                    ? new Date(workinghour.created_at)
                    : null,
                updated_at: workinghour.updated_at
                    ? new Date(workinghour.updated_at)
                    : null,
            };
        },

        parseWorkingHour(workinghour) {
            return WorkingHourFactory.construct(
                this.createMapperParameter(new WorkingHourMapperParameter()),
                workinghour
            );
        },

        parseWorkingHours(workinghours) {
            let parsedWorkingHours = [];

            workinghours.forEach((workinghourData) => {
                const workinghour = this.parseWorkingHour(workinghourData);
                parsedWorkingHours.push(workinghour);
            });

            return parsedWorkingHours;
        },

        getWorkingHour(id, payload, success, failure) {
            return this.getData(
                this.workingHourUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parseWorkingHour(response.data));
                },
                failure
            );
        },

        getWorkingHours(payload, success, failure) {
            return this.getData(
                this.workingHourUrl,
                payload,
                (response) => {
                    success(this.parseWorkingHours(response.data.data));
                },
                failure
            );
        },

        createWorkingHour(url, payload, success, failure) {
            return this.postData(
                url,
                payload,
                (response) => {
                    success(this.parseWorkingHour(response.data));
                },
                failure
            );
        },
    },
};
